export const ENTER_VALID_NVD_NUMBER_ERROR_MESSAGE = "Enter a valid NVD number";
